import { useFindUserDeviceType } from "capitalrx-components-2.0";
import GooglePlayStoreLogo from "../GoogleStoreLogo";
import AppStoreLogo from "../AppleStoreLogo";

import styles from "./DownloadApp.module.scss";

interface Props {
  className?: string;
}

const DownloadAppLogo: React.FC<Props> = ({ className }: Props) => {
  const currentDevice = useFindUserDeviceType();

  let appStore = null;
  let androidStore = null;

  if (currentDevice === "iOS" || currentDevice === null) {
    appStore = <AppStoreLogo className={styles.DownloadAppLogoIcon} />;
  }

  if (currentDevice === "Android" || currentDevice === null) {
    androidStore = <GooglePlayStoreLogo className={styles.DownloadAppLogoIcon} />;
  }

  return (
    <div className={styles.DownloadAppLogo}>
      {appStore}
      {androidStore}
    </div>
  );
};

export default DownloadAppLogo;
